import React from "react";
import { TListingFull1Editable } from "../../../../domain/codecs/formEditable/ListingEditable";
import { ListingPriceAndCosts } from "../../../../domain/codecs/Listing";
import { CRMAutosaveIndicatorWrap } from "../CRM/CRMAutosaveIndicatorWrap/CRMAutosaveIndicatorWrap";
import { CRMCodecEditForm } from "../CRMCodecEditForm/CRMCodecEditForm";
import { CRMSpacingColumn } from "../CRMSpacingColumn/CRMSpacingColumn";
import { CRMTitleSection } from "../CRMTitleSection/CRMTitleSection";

type TCRMListingPriceAndCostsFormProps = {
    listingForm: TListingFull1Editable;
    onChange: (listingForm: TListingFull1Editable) => void;
};

export const CRMListingPriceAndCostsForm = (props: TCRMListingPriceAndCostsFormProps): JSX.Element => {

    return (
        <CRMAutosaveIndicatorWrap status={props.listingForm.status}>
            <CRMSpacingColumn spacing="large">
                <CRMTitleSection>
                    Price & Costs
                </CRMTitleSection>
                <CRMCodecEditForm
                    codec={ListingPriceAndCosts}
                    model={props.listingForm.edited}
                    validationErrors={props.listingForm.validationErrors}
                    columns={2}
                    onChange={(edited) => props.onChange({
                        ...props.listingForm,
                        edited: {
                            ...props.listingForm.edited,
                            ...edited,
                        }
                    })}
                />
            </CRMSpacingColumn>
        </CRMAutosaveIndicatorWrap>
    );
};
